import {h, Fragment} from "preact"
import { AutocompleteElement } from "@nosto/preact"
import { useState, useEffect } from "preact/hooks"
import { productImagePlaceholder, fetchProductData, formatShopifyMoney, getSrc } from "../helpers"

export default function AutocompleteProduct({ hit }) {
    const [ prices, setPrices ] = useState({
        price: hit.price,
        listPrice: hit.listPrice
    })

    useEffect(() => {
        if(window.Shopify?.country !== 'US') {
            fetchProductData(hit.productId)
            .then(data => {
                const productPrice = data?.data?.products?.edges?.[0]?.node.priceRange;
                if(!productPrice) return;
                const price = productPrice.minVariantPrice?.amount;
                const listPrice = productPrice.maxVariantPrice?.amount;
                setPrices({ price, listPrice })
            })
        }
    }, [])

    return (
        <AutocompleteElement 
            hit={hit} 
            key={hit.productId}
        >
            <div
                data-url={hit.url}
                class="ns-d-flex flex-row ns-flex-column ns-clickable ns-p-2"
                data-nosto-element="product"
            >
                <a href="javascript:void(0)">
                    <img
                        class="ns-h-auto ns-object-contain"
                        src={getSrc(hit.imageUrl, 480) || hit.thumbUrl || productImagePlaceholder}
                        alt={hit.name}
                        style="width: 100%;"
                    />
                </a>
                <div class="ns-pl-2">
                    <div class="ns-clipped ns-text-one-line ns-font-6">
                        {hit.name.includes("-") && hit.name.split("-").shift()}
                        {!hit.name.includes("-") && hit.name}
                    </div>
                    <div class="ns-mb-2 ns-font-6">{hit.name.includes("-") && hit.name.split("-").pop()}</div>
                    <div>
                        <span class={`ns-font-6 ${prices.listPrice == prices.price ? 'ns-color-black' : 'ns-color-red ns-font-bold'}`}
                            dangerouslySetInnerHTML={{ 
                                __html: formatShopifyMoney(prices.price) 
                            }}
                        />
                        {(prices.listPrice && prices.listPrice > prices.price) && (
                            <span class="ns-color-black ns-text-striked ns-ml-2 ns-font-6"
                                dangerouslySetInnerHTML={{ 
                                    __html: formatShopifyMoney(prices.listPrice) 
                                }}
                            />
                        )}
                    </div>
                </div>
            </div>
        </AutocompleteElement>
    )
}
